import React, { useState } from "react"
import Hero from "../components/Hero"
import Seo from "../components/seo"
import { Container } from "../styles"
import {
  ContactIcons,
  Error,
  Form,
  FormButtonContainer,
  FormGroup,
  InputGroup,
  LoaderContainer,
  Success,
} from "../styles/pages/contact"
import { colorClaro } from "../styles/variables"
import {
  FaWhatsapp,
  FaRegEnvelope,
  FaPhoneAlt,
  FaRegUser,
  FaBriefcase,
  FaCheckCircle,
  FaExclamationCircle,
} from "react-icons/fa"
import { emailTemplate } from "../assets/email"
import { useTranslate } from "react-translate"
import ReactHtmlParser from "react-html-parser"
import { useItems } from "../hooks/useItems"

const ContactView = ({ info }) => {
  const [name, setName] = useState("")
  const [project, setProject] = useState("")
  const [email, setEmail] = useState("")
  const [idea, setIdea] = useState("")
  const [success, setSuccess] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const contactItems = useItems("contactItems").content[0]

  const contactText = info.Cuerpo[0]

  function handleSubmit(e) {
    setLoading(true)
    e.preventDefault()

    const bodyEmail = emailTemplate(name)

    send(
      "info@orbittas.com",
      `Project: ${project}.<br/>Name: ${name}.<br/>Email: ${email}. <br/>Message: <br/>${idea}`,
      true
    )

    send(email, bodyEmail)

    function send(to, body, isToUs) {
      window.Email.send({
        SecureToken: "4749d56d-8183-4551-8660-5b20c19dbd41",
        To: `${to}`,
        From: "orbittasd@gmail.com",
        Subject: `${project}`,
        Body: `${body}`,
      }).then(message => {
        if (isToUs) {
          console.log("hola")

          setLoading(false)
          if (message === "OK") {
            setSuccess(true)

            setName("")
            setProject("")
            setEmail("")
            setIdea("")
          } else {
            console.log(message)
            setError(true)
          }
        }

        message !== "OK" && console.log(message)
      })
    }
  }

  return (
    <>
      <Seo title={contactText.Title} />
      <Hero title={contactText.Title} bg={"contacto-bg.png"} />
      <section
        style={{
          background: colorClaro,
        }}
      >
        <Container>
          <h2
            style={{
              textAlign: "center",
              textTransform: "uppercase",
            }}
          >
            {contactText.Subtitle}
          </h2>

          <ContactIcons>
            <li>
              <a
                href={`mailto:${contactItems.email}`}
                target="_blank"
                rel="noreferrer"
              >
                <FaRegEnvelope />
                <span>{contactItems.email}</span>
              </a>
            </li>
            <li>
              <a
                href={contactItems.WhatsappLink}
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp />
                <span>{contactItems.phoneNumber}</span>
              </a>
            </li>
            <li>
              <a
                href={`tel:${contactItems.phoneNumber}`}
                target="_blank"
                rel="noreferrer"
              >
                <FaPhoneAlt />
                <span>{contactItems.phoneNumber}</span>
              </a>
            </li>
          </ContactIcons>

          <Form onSubmit={handleSubmit}>
            <FormGroup area={"name"}>
              <label>{contactText.LabelName}</label>
              <InputGroup>
                <FaRegUser />
                <input
                  type="text"
                  placeholder="Luis Lopez"
                  onChange={e => {
                    setName(e.target.value)
                  }}
                  value={name}
                  name="name"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup area={"email"}>
              <label>{contactText.LabelEmail}</label>
              <InputGroup>
                <FaRegEnvelope />
                <input
                  type="text"
                  placeholder="correo@dominio.com"
                  onChange={e => {
                    setEmail(e.target.value)
                  }}
                  value={email}
                  name="email"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup area={"project"}>
              <label>{contactText.LabelProject}</label>
              <InputGroup>
                <FaBriefcase />
                <input
                  type="text"
                  placeholder={contactText.PlaceholderProject}
                  onChange={e => {
                    setProject(e.target.value)
                  }}
                  value={project}
                  name="project"
                />
              </InputGroup>
            </FormGroup>
            <FormGroup area={"message"}>
              <label>{contactText.LabelMessage}</label>
              <textarea
                onChange={e => {
                  setIdea(e.target.value)
                }}
                value={idea}
                name="idea"
              ></textarea>
            </FormGroup>

            <FormButtonContainer succes={!success}>
              <button type="submit">{contactText.SubmitText}</button>
              {loading && (
                <LoaderContainer>
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </LoaderContainer>
              )}
              {success && (
                <Success>
                  <FaCheckCircle />
                  <h3>{contactText.Sucess}</h3>
                </Success>
              )}
              {error && (
                <Error>
                  <FaExclamationCircle />
                  <h3>{contactText.Error}</h3>
                </Error>
              )}
            </FormButtonContainer>
          </Form>
        </Container>
      </section>
    </>
  )
}

export default ContactView
